import {map} from 'lodash';

import {MenuItem} from '../MenuItem';
import {MenuItemInfo} from '../types';

type Props = {
    menuItems: MenuItemInfo[]
}

export const MainMenu: React.FC<Props> = (({menuItems}: Props) => (
    <nav className='tw-fixed tw-bottom-0 tw-h-16 tw-border-0 tw-bg-layout tw-z-main-menu
            tw-flex tw-w-full tw-justify-around tw-shadow-xl tw-items-center
            lg:tw-h-auto lg:tw-border-r lg:tw-border-default lg:tw-w-52 lg:tw-pr-5 lg:tw-block lg:tw-shadow-none
            lg:tw-top-20 lg:tw-bottom-20 lg:tw-overflow-auto -lg-landscape:tw-h-10'
    >
        {map(menuItems, (item, i) => <MenuItem key={i} {...item} />)}
    </nav>
));
